import { ValidateChildCorpNamesResponse } from 'src/components/enterprise/Parents/Children/ParentChildAccountController/types';

export const childNameErrorsArrayToMap = (
  response: ValidateChildCorpNamesResponse
): Record<string, string[]> => {
  return response.reduce<Record<string, string[]>>((acc, error) => {
    acc[error.property] = acc[error.property] || [];
    acc[error.property].push(error.message_key);
    return acc;
  }, {});
};
